module.exports = __webpack_public_path__ + "img/pwang.022c27a7.jpeg";